module.exports = __webpack_public_path__ + "static/4i-5cad650422a7184467af5a4d17b264c4.woff2";